export default "__VITE_ASSET__Bh4Yaf_q__"